import { render, staticRenderFns } from "./SalaryExcelMonthYX.vue?vue&type=template&id=5dace41f&scoped=true&"
import script from "./SalaryExcelMonthYX.vue?vue&type=script&lang=js&"
export * from "./SalaryExcelMonthYX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dace41f",
  null
  
)

export default component.exports